import React, { useEffect, useState } from "react";
import { Typography, Box, Paper, Tabs, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { RecentlyAddedRecords } from "./RecentlyAddedRecords";
import { PriceNotSetRecords } from "./PriceNotSetRecords";
import { StatusNotMatch } from "./StatusNotMatch";
import { SpecialsNotMatch } from "./SpecialsNotMatch";
import { RecentlyChangedRecords } from "./RecentlyChangedRecords";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={2}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  tabsWrapper: {
    borderRadius: 8,
    border: '1px solid rgba(0,0,0,0.1)',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  tab: {
    fontSize: '0.875rem',
    fontWeight: 500,
    minWidth: 140,
    '&:hover': {
      backgroundColor: 'rgba(63, 81, 181, 0.06)',
      transition: 'background-color 0.2s',
    },
  },
}));

export function RecordsPage(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ width: "1300px" }}>
      <Paper className={classes.tabsWrapper} elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="simple tabs example"
        >
          <Tab className={classes.tab} label="Recently Added" {...a11yProps(0)} />
          <Tab className={classes.tab} label="Prices Not Set" {...a11yProps(1)} />
          <Tab className={classes.tab} label="Status Does Not Match" {...a11yProps(2)} />
          <Tab className={classes.tab} label="Specials Does Not Match" {...a11yProps(3)} />
          <Tab className={classes.tab} label="Recently Changed" {...a11yProps(4)} />
        </Tabs>
      </Paper>
      <TabPanel value={value} index={0}>
        <RecentlyAddedRecords />
      </TabPanel>
      <TabPanel value={value} index={1}>
       <PriceNotSetRecords/>
      </TabPanel>
      <TabPanel value={value} index={2}>
      <StatusNotMatch/>
      </TabPanel>
      <TabPanel value={value} index={3}>
      <SpecialsNotMatch/>
      </TabPanel>
      <TabPanel value={value} index={4}>
        <RecentlyChangedRecords />
      </TabPanel>
    </div>
  );
}
